/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetExerciseVideoSchema } from '../models/GetExerciseVideoSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExercisesVideosApi {
    /**
     * Patch Exercise Video Api
     * Patch exercise video.<br>Required permission: edit_exercises
     * @returns GetExerciseVideoSchema OK
     * @throws ApiError
     */
    public static exercisesVideosPatchExerciseVideoApiPatch({
        exerciseVideoId,
    }: {
        exerciseVideoId: string,
    }): CancelablePromise<GetExerciseVideoSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/exercises-videos/{exercise_video_id}/',
            path: {
                'exercise_video_id': exerciseVideoId,
            },
        });
    }
}
